module.exports = __webpack_public_path__ + "static/media/c-plusplus.75a7eca4.svg";